import axios from "axios";
import {
  PUBLIC_PATIENT_TREATMENT_PLAN_LIST_REQUEST,
  PUBLIC_PATIENT_TREATMENT_PLAN_LIST_SUCCESS,
  PUBLIC_PATIENT_TREATMENT_PLAN_LIST_FAIL,
  PUBLIC_PATIENT_TREATMENT_PLAN_DETAILS_REQUEST,
  PUBLIC_PATIENT_TREATMENT_PLAN_DETAILS_SUCCESS,
  PUBLIC_PATIENT_TREATMENT_PLAN_DETAILS_FAIL,
  PUBLIC_TENANT_DETAILS_REQUEST,
  PUBLIC_TENANT_DETAILS_SUCCESS,
  PUBLIC_TENANT_DETAILS_FAIL,
  PUBLIC_PATIENT_APPROVE_TREATMENT_PLAN_REQUEST,
  PUBLIC_PATIENT_APPROVE_TREATMENT_PLAN_SUCCESS,
  PUBLIC_PATIENT_APPROVE_TREATMENT_PLAN_FAIL,
  PUBLIC_PATIENT_CANCEL_TREATMENT_PLAN_REQUEST,
  PUBLIC_PATIENT_CANCEL_TREATMENT_PLAN_SUCCESS,
  PUBLIC_PATIENT_CANCEL_TREATMENT_PLAN_FAIL,
  PUBLIC_PATIENT_DOWNLOADPDF_TREATMENT_PLAN_REQUEST,
  PUBLIC_PATIENT_DOWNLOADPDF_TREATMENT_PLAN_SUCCESS,
  PUBLIC_PATIENT_DOWNLOADPDF_TREATMENT_PLAN_FAIL,
  PUBLIC_COURSES_LIST_REQUEST,
  PUBLIC_COURSES_LIST_SUCCESS,
  PUBLIC_COURSES_LIST_FAIL,
  PUBLIC_ATTENDEE_COURSE_REGISTER_REQUEST,
  PUBLIC_ATTENDEE_COURSE_REGISTER_SUCCESS,
  PUBLIC_ATTENDEE_COURSE_REGISTER_FAIL,
  PUBLIC_INVITE_INFO_REQUEST,
  PUBLIC_INVITE_INFO_SUCCESS,
  PUBLIC_INVITE_INFO_FAIL,
  PUBLIC_ACCEPT_INVITE_REQUEST,
  PUBLIC_ACCEPT_INVITE_SUCCESS,
  PUBLIC_ACCEPT_INVITE_FAIL,
  PUBLIC_PORTAL_PATIENT_DETAILS_REQUEST,
  PUBLIC_PORTAL_PATIENT_DETAILS_SUCCESS,
  PUBLIC_PORTAL_PATIENT_DETAILS_FAIL,
  PUBLIC_PORTAL_PATIENT_VERIFY_PIN_REQUEST,
  PUBLIC_PORTAL_PATIENT_VERIFY_PIN_SUCCESS,
  PUBLIC_PORTAL_PATIENT_VERIFY_PIN_FAIL,
  PUBLIC_PORTAL_GET_TREATMENT_PLANS_REQUEST,
  PUBLIC_PORTAL_GET_TREATMENT_PLANS_SUCCESS,
  PUBLIC_PORTAL_GET_TREATMENT_PLANS_FAIL,
  PUBLIC_PORTAL_TREATMENT_PLAN_APPROVE_REQUEST,
  PUBLIC_PORTAL_TREATMENT_PLAN_APPROVE_SUCCESS,
  PUBLIC_PORTAL_TREATMENT_PLAN_APPROVE_FAIL,
  PUBLIC_PORTAL_TREATMENT_PLAN_CANCEL_REQUEST,
  PUBLIC_PORTAL_TREATMENT_PLAN_CANCEL_SUCCESS,
  PUBLIC_PORTAL_TREATMENT_PLAN_CANCEL_FAIL,
  PUBLIC_PORTAL_TREATMENT_PLAN_DOWNLOADPDF_REQUEST,
  PUBLIC_PORTAL_TREATMENT_PLAN_DOWNLOADPDF_SUCCESS,
  PUBLIC_PORTAL_TREATMENT_PLAN_DOWNLOADPDF_FAIL,
  PUBLIC_CHECK_USER_INVITE_REQUEST,
  PUBLIC_CHECK_USER_INVITE_SUCCESS,
  PUBLIC_CHECK_USER_INVITE_FAIL,
} from "../constants/publicConstants";

export const listPublicPatientTreatmentPlanList =
  (tenantId, userId) => async (dispatch) => {
    try {
      dispatch({ type: PUBLIC_PATIENT_TREATMENT_PLAN_LIST_REQUEST });

      const { data } = await axios.get(
        `/api/public/tenant/${tenantId}/users/${userId}/treatment-plans`
      );

      // console.log(data);
      // console.log("tenantId: ", tenantId);
      // console.log("userId: ", userId);

      dispatch({
        type: PUBLIC_PATIENT_TREATMENT_PLAN_LIST_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: PUBLIC_PATIENT_TREATMENT_PLAN_LIST_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const listPublicPatientTreatmentPlanDetails =
  (tenantId, userId, treatmentPlanId) => async (dispatch) => {
    try {
      dispatch({ type: PUBLIC_PATIENT_TREATMENT_PLAN_DETAILS_REQUEST });

      const { data } = await axios.get(
        `/api/public/tenant/${tenantId}/users/${userId}/treatment-plans/${treatmentPlanId}`
      );

      dispatch({
        type: PUBLIC_PATIENT_TREATMENT_PLAN_DETAILS_SUCCESS,
        payload: data,
      });

      // console.log(data);
    } catch (error) {
      dispatch({
        type: PUBLIC_PATIENT_TREATMENT_PLAN_DETAILS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const listPublicTenantDetails = (tenantId) => async (dispatch) => {
  try {
    dispatch({ type: PUBLIC_TENANT_DETAILS_REQUEST });

    const { data } = await axios.get(`/api/public/tenant/${tenantId}`);

    dispatch({
      type: PUBLIC_TENANT_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: PUBLIC_TENANT_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const approveTreatmentPlanPatientPublic =
  (tenantId, userId, treatmentPlanId) => async (dispatch) => {
    try {
      dispatch({ type: PUBLIC_PATIENT_APPROVE_TREATMENT_PLAN_REQUEST });

      const { data } = await axios.put(
        `/api/public/tenant/${tenantId}/users/${userId}/treatment-plans/${treatmentPlanId}/approve`
      );

      // console.log(data);

      dispatch({
        type: PUBLIC_PATIENT_APPROVE_TREATMENT_PLAN_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: PUBLIC_PATIENT_APPROVE_TREATMENT_PLAN_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const cancelTreatmentPlanPatientPublic =
  (tenantId, userId, treatmentPlanId, cancelledReason, cancelledComment) =>
  async (dispatch) => {
    try {
      dispatch({ type: PUBLIC_PATIENT_CANCEL_TREATMENT_PLAN_REQUEST });

      const { data } = await axios.put(
        `/api/public/tenant/${tenantId}/users/${userId}/treatment-plans/${treatmentPlanId}/cancel`,
        { cancelledReason, cancelledComment } // Send these in the request body
      );

      // console.log(data);

      dispatch({
        type: PUBLIC_PATIENT_CANCEL_TREATMENT_PLAN_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: PUBLIC_PATIENT_CANCEL_TREATMENT_PLAN_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };
export const downloadTreatmentPlanPdfPublic =
  (tenantId, userId, treatmentPlanId, language) => async (dispatch) => {
    try {
      dispatch({
        type: PUBLIC_PATIENT_DOWNLOADPDF_TREATMENT_PLAN_REQUEST,
      });

      const config = {
        responseType: "blob", // Important for handling binary data like PDF
      };

      const { data } = await axios.get(
        `/api/public/tenant/${tenantId}/users/${userId}/treatment-plans/${treatmentPlanId}/generate-download-pdf?language=${language}`, // Append language as a query parameter
        config // Pass the configuration object to the request
      );

      // console.log("data: ", data);

      dispatch({
        type: PUBLIC_PATIENT_DOWNLOADPDF_TREATMENT_PLAN_SUCCESS,
        payload: data,
      });

      // console.log("data: ", data);

      // Code to trigger the browser to download the PDF file
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `treatment-plan-${treatmentPlanId}.pdf`); // or any other name you want
      document.body.appendChild(link);
      link.click();

      return { success: true, payload: data };
    } catch (error) {
      const errorMessage =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;

      dispatch({
        type: PUBLIC_PATIENT_DOWNLOADPDF_TREATMENT_PLAN_FAIL,
        payload: errorMessage,
      });

      // Return an object indicating failure and the error message
      return { success: false, error: errorMessage };
    }
  };

export const listPublicCourses = (tenantId) => async (dispatch) => {
  try {
    dispatch({ type: PUBLIC_COURSES_LIST_REQUEST });

    const { data } = await axios.get(`/api/public/tenant/${tenantId}/courses`);

    dispatch({
      type: PUBLIC_COURSES_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: PUBLIC_COURSES_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const registerAttendeeToCoursePublic =
  (tenantId, courseId, attendeeData) => async (dispatch) => {
    try {
      dispatch({ type: PUBLIC_ATTENDEE_COURSE_REGISTER_REQUEST });

      const { data } = await axios.post(
        `/api/public/tenant/${tenantId}/courses/course-register`,
        {
          courseId,
          ...attendeeData,
        }
      );

      dispatch({
        type: PUBLIC_ATTENDEE_COURSE_REGISTER_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: PUBLIC_ATTENDEE_COURSE_REGISTER_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const getPublicInviteInfoAction =
  (slug, email, token) => async (dispatch) => {
    try {
      dispatch({ type: PUBLIC_INVITE_INFO_REQUEST });

      const { data } = await axios.get(
        `/api/public/invite/info?slug=${slug}&email=${encodeURIComponent(
          email
        )}&token=${token}`
      );

      dispatch({
        type: PUBLIC_INVITE_INFO_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: PUBLIC_INVITE_INFO_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// export const acceptInviteAction =
//   (email, password, name, slug, token, isGlobalUser) => async (dispatch) => {
//     try {
//       dispatch({ type: PUBLIC_ACCEPT_INVITE_REQUEST });

//       const { data } = await axios.post("/api/public/invite/accept", {
//         email,
//         password,
//         name,
//         slug,
//         token,
//         isGlobalUser, // 🧠 send this
//       });

//       dispatch({ type: PUBLIC_ACCEPT_INVITE_SUCCESS, payload: data });
//     } catch (error) {
//       dispatch({
//         type: PUBLIC_ACCEPT_INVITE_FAIL,
//         payload: error.response?.data?.message || error.message,
//       });
//     }
//   };
export const acceptInviteAction =
  (email, password, name, slug, token, isGlobalUser, language) =>
  async (dispatch) => {
    try {
      dispatch({ type: PUBLIC_ACCEPT_INVITE_REQUEST });

      const { data } = await axios.post("/api/public/invite/accept", {
        email,
        password,
        name,
        slug,
        token,
        isGlobalUser,
        language,
      });

      // ✅ Store token in localStorage and Redux (mimic login)
      localStorage.setItem("userInfo", JSON.stringify(data));
      dispatch({ type: PUBLIC_ACCEPT_INVITE_SUCCESS, payload: data });

      // ✅ Also dispatch login success manually (optional but clean)
      dispatch({ type: "AUTH_LOGIN_SUCCESS", payload: data });
    } catch (error) {
      dispatch({
        type: PUBLIC_ACCEPT_INVITE_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

export const getPublicPortalPatientDetailsAction =
  (slug, patientId) => async (dispatch) => {
    try {
      dispatch({ type: PUBLIC_PORTAL_PATIENT_DETAILS_REQUEST });

      const { data } = await axios.get(
        `/api/public/${slug}/portal/${patientId}`
      );

      dispatch({
        type: PUBLIC_PORTAL_PATIENT_DETAILS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: PUBLIC_PORTAL_PATIENT_DETAILS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const publicVerifyPatientPortalPinAction =
  (slug, patientId, pinCode) => async (dispatch) => {
    try {
      dispatch({ type: PUBLIC_PORTAL_PATIENT_VERIFY_PIN_REQUEST });

      const { data } = await axios.post(
        `/api/public/${slug}/portal/${patientId}/verify-pin`,
        { pinCode }
      );

      dispatch({
        type: PUBLIC_PORTAL_PATIENT_VERIFY_PIN_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: PUBLIC_PORTAL_PATIENT_VERIFY_PIN_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const publicGetPortalPatientTreatmentPlansAction =
  (slug, patientId, token) => async (dispatch) => {
    try {
      dispatch({ type: PUBLIC_PORTAL_GET_TREATMENT_PLANS_REQUEST });

      if (!token) {
        throw new Error("No token provided");
      }

      const config = {
        headers: {
          Authorization: `Bearer ${token}`, // ✅ use the prop
        },
      };

      const { data } = await axios.get(
        `/api/public/${slug}/portal/${patientId}/treatment-plans`,
        config
      );

      // console.log("data: ", data);

      dispatch({
        type: PUBLIC_PORTAL_GET_TREATMENT_PLANS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: PUBLIC_PORTAL_GET_TREATMENT_PLANS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const publicApproveTreatmentPlanFromSharedLinkAction =
  (slug, patientId, treatmentPlanId, token) => async (dispatch) => {
    try {
      dispatch({ type: PUBLIC_PORTAL_TREATMENT_PLAN_APPROVE_REQUEST });

      if (!token) {
        throw new Error("No token provided");
      }

      const config = {
        headers: {
          Authorization: `Bearer ${token}`, // ✅ use the prop
        },
      };

      const { data } = await axios.get(
        `/api/public/${slug}/portal/${patientId}/treatment-plans/${treatmentPlanId}/approve`,
        config
      );

      // console.log("data: ", data);

      dispatch({
        type: PUBLIC_PORTAL_TREATMENT_PLAN_APPROVE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: PUBLIC_PORTAL_TREATMENT_PLAN_APPROVE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const publicCancelTreatmentPlanFromSharedLinkAction =
  (
    slug,
    patientId,
    treatmentPlanId,
    cancelledReason,
    cancelledComment,
    token
  ) =>
  async (dispatch) => {
    try {
      dispatch({ type: PUBLIC_PORTAL_TREATMENT_PLAN_CANCEL_REQUEST });

      if (!token) {
        throw new Error("No token provided");
      }

      const config = {
        headers: {
          Authorization: `Bearer ${token}`, // ✅ use the prop
        },
      };

      // console.log("token: ", token);

      const { data } = await axios.put(
        `/api/public/${slug}/portal/${patientId}/treatment-plans/${treatmentPlanId}/cancel`,
        {
          cancelledReason,
          cancelledComment,
        },
        config
      );

      // console.log("ACTION DATA: ", data);

      dispatch({
        type: PUBLIC_PORTAL_TREATMENT_PLAN_CANCEL_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: PUBLIC_PORTAL_TREATMENT_PLAN_CANCEL_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const publicDownloadTreatmentPlanPdfFromSharedLinkAction =
  (slug, patientId, treatmentPlanId, token, language) => async (dispatch) => {
    try {
      dispatch({ type: PUBLIC_PORTAL_TREATMENT_PLAN_DOWNLOADPDF_REQUEST });

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob", // 👈 Important to handle binary PDF response
      };

      if (!token) {
        throw new Error("No token provided");
      }

      const { data } = await axios.get(
        `/api/public/${slug}/portal/${patientId}/treatment-plans/${treatmentPlanId}/download?language=${language}`, // Append language as a query parameter
        config
      );

      // console.log("slug: ", slug);
      // console.log("patientId: ", patientId);
      // console.log("treatmentPlanId: ", treatmentPlanId);
      // console.log("token: ", token);
      // console.log("language: ", language);

      // console.log("data: ", data);

      dispatch({ type: PUBLIC_PORTAL_TREATMENT_PLAN_DOWNLOADPDF_SUCCESS });

      // You can optionally return the blob for file saving (e.g., with file-saver)
      return data;
    } catch (error) {
      dispatch({
        type: PUBLIC_PORTAL_TREATMENT_PLAN_DOWNLOADPDF_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

export const checkUserInviteAction = (token, slug) => async (dispatch) => {
  try {
    dispatch({ type: PUBLIC_CHECK_USER_INVITE_REQUEST });

    const { data } = await axios.get(
      `/api/public/invite/check?token=${token}&slug=${slug}`
    );

    dispatch({
      type: PUBLIC_CHECK_USER_INVITE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: PUBLIC_CHECK_USER_INVITE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
